
import React from 'react';
import { Button } from '../../../components/base/Button';

export const AboutSection: React.FC = () => {
  const stats = [
    { number: '500+', label: 'Clients Served', icon: 'ri-user-line' },
    { number: '15+', label: 'Years Experience', icon: 'ri-time-line' },
    { number: '$50M+', label: 'Assets Managed', icon: 'ri-money-dollar-circle-line' },
    { number: '98%', label: 'Client Satisfaction', icon: 'ri-star-line' }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              About <span className="text-blue-600">HUGH MUIR INVESTMENT CORP</span>
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              With over 15 years of experience in investment management and financial advisory, HUGH MUIR INVESTMENT CORP has been helping individuals and businesses achieve their financial goals through strategic planning and expert guidance. Our comprehensive approach combines investment management, wealth planning, and portfolio advisory to deliver personalized solutions that drive sustainable growth.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We believe that every client deserves a customized approach to their financial future. Our team of certified investment advisors and financial planning experts work closely with you to understand your unique situation, goals, and challenges, then develop investment strategies that align with your vision for success.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="primary" 
                size="lg"
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              >
                <i className="ri-phone-line mr-2"></i>
                Get Started Today
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                href="#expertise"
              >
                <i className="ri-team-line mr-2"></i>
                Meet Our Team
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <img 
              alt="HUGH MUIR INVESTMENT CORP Team" 
              className="w-full rounded-2xl shadow-2xl object-cover object-top"
              src="https://public.readdy.ai/ai/img_res/3b5d2995fad23cf8ae41a95d62da9242.jpg"
            />
            
            <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center mb-3">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-award-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Certified Experts</h4>
                  <p className="text-sm text-gray-600">CFP & CFA Certified</p>
                </div>
              </div>
              <p className="text-sm text-gray-600">
                Our team holds the highest industry certifications and credentials.
              </p>
            </div>
          </div>
        </div>
        
        <div className="mt-20">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-2xl text-blue-600`}></i>
                </div>
                <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-600 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
